(function (app, ng) {

    app.component("newFeature",
        {
            templateUrl: "/App/Components/NewFeature/new-feature.template.html",
            controller: newFeatureController,
            controllerAs: "newFeature",
            bindings: {
                iconClass: "@",
                message: "@",
                tooltip: "@"
            }
        });

    newFeatureController.$inject = ["$scope"];
    function newFeatureController($scope) {
        var $ctrl = this;
        $ctrl.$onInit = () => {
            $scope.iconClass = $ctrl.iconClass;
            $scope.message = $ctrl.message;
            $scope.tooltip = $ctrl.tooltip;

        };
    }
    
})(window.app, window.angular); //jshint ignore:line